/**
 * หน้าจอใบสั่งขาย (Sales Order, P2-4b) — รายการ ค้นหา และขับ lifecycle
 *
 * **การรับ Customer PO เข้าเป็นใบใหม่ย้ายไปเป็นหน้า drill-down เต็มหน้าแล้ว**
 * (`?view=receive`, `SalesOrderReceivePage.tsx`, D-116 ข้อ 3 และ 6, `WO-P2-M4-008`)
 * — ไม่ใช่กล่อง `Modal` อีกต่อไป ไฟล์นี้จึงทำหน้าที่เป็น "router" ของ view ทั้งสอง
 * แบบเดียวกับ `ProductMasterScreen`: `resolveSalesOrdersView` อ่าน search param
 * แล้วสลับว่าจะเรนเดอร์หน้ารายการ (ด้านล่าง) หรือส่งต่อให้ `SalesOrderReceivePage`
 * ทั้งหน้า — หน้ารายการ**ไม่ถูกเรนเดอร์เลย**ขณะอยู่ที่หน้าย่อย ไม่ใช่แค่ถูกบัง
 *
 * ปิดทั้งห้า operation ของ contract ที่ `WO-P2-M4-002` เปิดไว้ (D-090):
 * `GET`/`POST /v1/sales-orders`, `GET /{so_id}` และสอง transition
 * (`confirm`/`cancel`) — `POST` เดินทางผ่าน `SalesOrderReceivePage` แล้ว
 *
 * โครงยืมมาจาก `PurchaseOrderScreen` ทั้งท่อนโดยตั้งใจ — ช่องค้นหาบนสุด ปุ่ม
 * lifecycle รายแถว และหลังสำเร็จก็ **โหลดรายการใหม่ผ่าน client เส้นเดิม** ไม่ใช่
 * รีโหลดทั้งหน้า ใบสั่งขายเป็นภาพสะท้อนของใบสั่งซื้อ ความต่างทุกข้อจึงเป็นข้อที่
 * D-090 เขียนไว้ ไม่ใช่รสนิยม:
 *
 * 1. **รายการไม่มีบรรทัด** contract ตัด `lines` ออกจากทุก item ของ `GET` และคืน
 *    ครบเฉพาะ `GET /{so_id}` ตารางจึงแสดง **หัวใบล้วน** และผู้ใช้กด "ดูบรรทัด" เพื่อ
 *    ให้หน้าจอไปเอาใบนั้นใบเดียว — **ไม่มี loop ใดที่ยิงใบเดียวทีละแถว** ซึ่งเป็น
 *    สิ่งเดียวกับที่ contract ตั้งใจเลี่ยงตอนตัดบรรทัดออกจากรายการ
 * 2. **บรรทัดถูกกรอกด้วยมือทั้งบรรทัด** กล่องสร้างจึงมี line editor ที่เพิ่ม/ลบแถว
 *    ได้ ต่างจากใบสั่งซื้อที่ติ๊กใบขอซื้อที่อนุมัติแล้วมาเป็นบรรทัด — Customer PO
 *    เป็นเอกสารของลูกค้าที่เราคีย์เข้าระบบ ไม่ได้เกิดจากเอกสารภายในใบก่อนหน้า
 * 3. **`confirm` ใช้สิทธิ์ EDIT ไม่ใช่ APPROVE** ตามที่ contract ประกาศ แต่ยังคง
 *    กฎแบ่งแยกหน้าที่ข้อเดียวกัน (D-010): ผู้ยืนยันต้องไม่ใช่ผู้เปิดใบ ซึ่งเป็น
 *    `422 CONFIRMER_MUST_DIFFER_FROM_CREATOR` ไม่ใช่ `403`
 * 4. **สามสถานะที่ยังไม่มีใครเขียน** (`PLANNED`, `PARTIALLY_DELIVERED`, `DELIVERED`)
 *    ต้องแสดงได้ถ้าเซิร์ฟเวอร์ส่งมา — MRP (P2-6) และงานส่งของ (P2-9) จะเขียนมันใน
 *    อนาคต หน้าจอนี้อ่านมันออก มีป้ายไทยของตัวเอง และ **ไม่มีปุ่มใดให้กด**
 *
 * **D-118 (`WO-P2-M4-014`) เปลี่ยนรายการนี้จาก "หน้าเดียวที่กรองเอง" เป็นรายการจริง**
 * และห้าข้อนี้เกี่ยวพันกันทั้งชุด ไม่ใช่ห้าฟีเจอร์ที่บังเอิญมาพร้อมกัน:
 *
 * 1. **ค้นหาเป็นของเซิร์ฟเวอร์** (`?q=`) — ช่องค้นหาเดิมกรองจากหน้าที่โหลดมาแล้ว ซึ่ง
 *    ทันทีที่มี pagination มันกลายเป็นการค้นหา **แค่หน้าจอ**: ใบที่อยู่หน้าถัดไปจะถูก
 *    รายงานว่า "ไม่พบ" ทั้งที่มีอยู่จริง — คำตอบที่ผิดซึ่งอ่านเหมือนคำตอบที่ถูก
 * 2. **ตัวกรองทั้งหกอยู่ใน URL** ไม่ใช่ใน state ของ component — refresh ได้ ส่งลิงก์
 *    ต่อได้ และ `?view=receive` ที่อยู่ใน URL เดียวกัน (D-116 ข้อ 3) ไม่ถูกแตะเลย
 * 3. **pagination เป็นก่อนหน้า/ถัดไป + จำนวนรวม** ไม่ใช่เลขหน้า — cursor ไม่รู้ว่า
 *    ตัวเองเป็นหน้าที่เท่าไร แต่ `total` บอกได้ว่ากำลังดูส่วนไหนของสมุดคำสั่งซื้อ
 * 4. **การเลือกผูกกับตัวกรองและหน้าที่มันเกิดมา** (`ScopedSelection`) — การเลือกที่
 *    ค้างจากตัวกรองเก่าคือการ export ของที่มองไม่เห็นอยู่บนจอ
 * 5. **Export ส่งทางใดทางหนึ่ง**: `so_ids` ของแถวที่ติ๊ก หรือ **ตัวกรองปัจจุบัน** —
 *    ไม่ใช่ id นับพันที่หน้าจอต้องไล่เก็บจากทุกหน้าก่อนถึงจะส่งได้
 *
 * **D-120 (`WO-P2-M4-016`) รวมสองช่อง `type=date` ต่อหนึ่งช่วงเป็นช่องเดียว** —
 * `DateRangePicker` (component กลางที่ไม่รู้จัก sales) เลือกทั้ง "จาก" และ "ถึง" ใน
 * ปฏิทินเดียว คลิกที่สองก่อนวันเริ่มถูกสลับให้เอง **ช่วงกลับหัวจึงเกิดจากหน้าจอไม่ได้อีก**
 * — แต่กล่องเตือนช่วงกลับหัวด้านล่างยังอยู่ครบ เพราะ URL ที่พิมพ์เองยังพามันมาได้
 * ค่าใน URL และที่ส่งให้เซิร์ฟเวอร์ (`created_from/to`, `delivery_from/to`) ไม่เปลี่ยนเลย
 *
 * ⚠️ **ห้ามเพิ่มย่อหน้าคำอธิบายใหม่บนหน้านี้** (D-119) คำอธิบายของตัวกรอง/pagination/
 * checkbox/Export อยู่ใน `InfoHint` ข้าง label ที่มันอธิบาย ส่วนสถานะและ error แสดง
 * ตามปกติ — ย่อหน้าที่กินที่อยู่ทุกวินาทีที่เปิดหน้าคือสิ่งที่ผู้ใช้สั่งให้เอาออกไปแล้ว
 *
 * การ gate สิทธิ์เป็นแบบเดียวกับทุกหน้าจอธุรกิจ: `SALES` + `VIEW` เป็นสิทธิ์ของ
 * **การเปิดหน้าจอนี้** (ด่านอยู่ที่ route) ส่วน `CREATE` (รับใบเข้าระบบ) และ `EDIT`
 * (ยืนยัน/ยกเลิก) เป็นสิทธิ์ของ **ปุ่มที่เขียน** ซึ่งถูกบังคับข้างในนี้ทีละปุ่ม
 * ตรงกับด่านจริงฝั่งเซิร์ฟเวอร์ทีละเส้น
 *
 * ⚠️ ทั้งหมดนี้เป็น UX layer ไม่ใช่ด่านความปลอดภัย เซิร์ฟเวอร์เป็นผู้ตัดสินทุก request
 * เสมอ (`references/authorization-rbac.md` ข้อ 5)
 */

import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { SalesOrderReceivePage } from './SalesOrderReceivePage';
import { StatusBadge } from '../StatusBadge';
import { DateRangePicker } from '../components/DateRangePicker';
import { InfoHint } from '../components/InfoHint';
import { useTrailingCrumbs } from '../desktopContext';
import type { Breadcrumb } from '../HeaderBar';
import { can } from '../../lib/permissions/client';
import type { PermissionsState } from '../../lib/permissions/types';
import {
  cancelSalesOrder,
  confirmSalesOrder,
  currentStatusFromFailure,
  exportSalesOrders,
  fetchSalesOrder,
  fetchSalesOrders,
  ruleFromFailure,
  type ApiErrorEnvelope,
  type CustomerPoImportResult,
  type SalesOrderFailure,
  type SalesOrderTransition,
  type SalesOrderWriteResult,
} from '../../lib/sales/client';
import {
  DEFAULT_SALES_ORDER_PAGE_SIZE,
  EMPTY_SALES_ORDER_LIST_FILTERS,
  SALES_ORDER_PAGE_SIZES,
  SALES_ORDER_STATUS_DESCRIPTORS,
  areSalesOrderListFiltersRequestable,
  customerPoImportOutcomeLabel,
  customerPoImportOutcomeSummary,
  customerPoImportOutcomeTone,
  hasAnySalesOrderListFilter,
  isReversedDateRange,
  receiveSalesOrderSearch,
  requestedDeliveryDateLabel,
  resolveSalesOrderListFilters,
  resolveSalesOrderPageSize,
  resolveSalesOrdersView,
  salesOrderActionLabel,
  salesOrderActionPermission,
  salesOrderActionTargetStatus,
  salesOrderDeliverySpanLabel,
  salesOrderExportLabel,
  salesOrderExportRequest,
  salesOrderLifecycleActionsFor,
  salesOrderLineRefs,
  salesOrderListSearch,
  salesOrderRowRangeLabel,
  salesOrderStatusLabel,
  salesOrderStatusTone,
  spreadsheetImportFailureLocation,
  toSalesOrderListQueryFilters,
  type SalesOrderListFilters,
} from '../../lib/sales/salesView';
import {
  CONFIRMER_MUST_DIFFER_FROM_CREATOR,
  CUSTOMER_IS_BLOCKED,
  CUSTOMER_IS_INACTIVE,
  CUSTOMER_NOT_FOUND,
  CUSTOMER_PO_ALREADY_ORDERED,
  CUSTOMER_PO_LINE_NO_DUPLICATED,
  CUSTOMER_PO_NUMBER_MAX_LENGTH,
  PLANT_OUTSIDE_SCOPE,
  PRODUCT_NOT_ACTIVE,
  SALES_MODULE,
  SALES_ORDER_HAS_NO_LINES,
  SALES_ORDER_NOT_REVISABLE,
  SO_NUMBER_TAKEN,
  type SalesOrder,
  type SalesOrderLine,
  type SalesOrderListItem,
  type SalesOrderListPage,
  type SalesOrderSummary,
} from '../../lib/sales/types';

/* ------------------------------------------------- หน้าจอความล้มเหลว ----- */

type SalesOrderFailureContext =
  /** อ่านรายการใบสั่งขาย */
  | 'orders'
  /** อ่านใบเดียวเพื่อดูบรรทัด */
  | 'detail'
  /** รับ Customer PO เข้าเป็นใบใหม่ */
  | 'create'
  /** ขอไฟล์ `.xlsx` ของรายการ (D-118 ข้อ 5) — **อ่าน ไม่เขียน** */
  | 'export'
  /** กดปุ่ม lifecycle บนแถวใดแถวหนึ่ง */
  | SalesOrderTransition;

interface FailureCopy {
  readonly heading: string;
  readonly text: string;
}

/**
 * ประโยค "ไม่มีอะไรเปลี่ยน" ของแต่ละ context ที่ **เขียน** — สตริงว่างสำหรับ context
 * ที่อ่านอย่างเดียว
 *
 * ของ `create` ต้องพูดถึง **บรรทัด** ด้วย: ผู้ใช้ที่ถูกปฏิเสธกลางทางจะสงสัยว่าใบถูก
 * สร้างไปครึ่งใบหรือเปล่า คำตอบคือไม่ — หัวใบและบรรทัดอยู่ในคำขอเดียวและเป็น
 * all-or-nothing (D-090) นี่เป็นข้อเท็จจริงของ contract ไม่ใช่คำปลอบใจ
 */
function nothingChangedText(context: SalesOrderFailureContext): string {
  switch (context) {
    case 'create':
      return ' ไม่มีใบสั่งขายใบใดถูกเปิด ไม่มีบรรทัดใดถูกเขียน และไม่มีแถว audit ถูกเขียน';
    case 'confirm':
    case 'cancel':
      return ' ใบนี้ยังอยู่ในสถานะเดิมและไม่มีแถว audit ถูกเขียน';
    case 'orders':
    case 'detail':
    case 'export':
      // `POST /v1/sales-orders/export` เป็น `POST` ที่ **ไม่เขียนอะไรเลย** (D-118 ข้อ 5)
      // ประโยค "ไม่มีอะไรเปลี่ยน" จึงไม่มีอะไรให้ปลอบใจ — มันไม่เคยเปลี่ยนตั้งแต่แรก
      return '';
  }
}

function isWriteContext(context: SalesOrderFailureContext): boolean {
  return nothingChangedText(context) !== '';
}

/**
 * ข้อความของกฎแต่ละข้อ — คืน `null` เมื่อไม่ใช่กฎที่ contract เขียนไว้
 *
 * ⚠️ ห้ามเพิ่มรหัสที่ contract ไม่ได้ระบุลงใน `switch` นี้ — รหัสที่หน้าจอคิดขึ้นเอง
 * คือข้อความที่ไม่มีวันแสดง และเป็นคำสัญญาที่ backend ไม่เคยให้ไว้ **โดยเฉพาะการ
 * ปฏิเสธ transition ซึ่ง contract ไม่ได้ตั้งชื่อรหัสกฎไว้เลย** — มันถูกอธิบายจาก
 * `details.current_status` แทน (ดู `conflictCopy()`)
 */
function ruleCopy(rule: string | null): FailureCopy | null {
  switch (rule) {
    case SO_NUMBER_TAKEN:
      return {
        heading: 'เลขใบสั่งขายที่เซิร์ฟเวอร์เพิ่งออกให้ชนกับใบอื่นพอดี',
        text: `เซิร์ฟเวอร์ตอบ 409 พร้อมกฎ ${SO_NUMBER_TAKEN} — เลขใบสั่งขายออกโดยเซิร์ฟเวอร์เองเสมอ (D-113) นี่คือการชิงเลขกันของคำขอสองใบที่มาถึงพร้อมกัน กดส่งซ้ำอีกครั้งเพื่อรับเลขใหม่ **ใบที่ถือเลขนี้อยู่ไม่ถูกทับ และสิ่งที่กรอกไว้ในกล่องนี้ยังอยู่ครบ**`,
      };
    case CUSTOMER_PO_ALREADY_ORDERED:
      return {
        heading: 'ใบสั่งซื้อของลูกค้ารายนี้ถูกรับเข้าระบบไปแล้ว',
        text: `เซิร์ฟเวอร์ตอบ 409 พร้อมกฎ ${CUSTOMER_PO_ALREADY_ORDERED} — มีใบสั่งขายที่อ้างลูกค้ารายนี้กับเลข PO เลขนี้อยู่แล้ว **นี่คือด่านที่กันไม่ให้เราผลิตและส่งของสองรอบสำหรับคำสั่งซื้อใบเดียวของลูกค้า** ค้นเลข PO นั้นในช่องค้นหาด้านบนเพื่อดูใบที่มีอยู่ — ถ้าลูกค้าแก้ใบเดิมจริง นั่นคือการแก้ไขใบ (revision) ซึ่งเป็นงานคนละอย่าง ไม่ใช่การรับใบใหม่ ไม่มีอะไรถูกเขียนเลย`,
      };
    case PLANT_OUTSIDE_SCOPE:
      return {
        heading: 'โรงงานที่ระบุอยู่นอกขอบเขตของคุณ',
        text: `เซิร์ฟเวอร์ตอบ 403 พร้อมกฎ ${PLANT_OUTSIDE_SCOPE} — ใบสั่งขายเป็นของโรงงานเดียว และคุณรับใบให้โรงงานที่ไม่ได้อยู่ในสิทธิ์เข้าถึงของตัวเองไม่ได้ (D-004) ตรวจรหัสโรงงาน หรือขอสิทธิ์เข้าถึงโรงงานนั้นเพิ่ม`,
      };
    case CUSTOMER_NOT_FOUND:
      return {
        heading: 'ไม่พบลูกค้ารหัสนี้',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${CUSTOMER_NOT_FOUND} — ไม่มีลูกค้ารหัสนี้ในทะเบียน ตรวจรหัสอีกครั้งจากหน้า "ลูกค้า (Customer Master)"`,
      };
    case CUSTOMER_IS_BLOCKED:
      return {
        heading: 'ลูกค้ารายนี้ถูกระงับ — รับคำสั่งซื้อใหม่ไม่ได้',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${CUSTOMER_IS_BLOCKED} — ลูกค้าที่ถูกระงับ (BLOCKED) รับคำสั่งซื้อใหม่ไม่ได้ **ไม่ใช่เรื่องสิทธิ์ของคุณ** และการกดซ้ำหรือขอสิทธิ์เพิ่มไม่ช่วยอะไร การระงับเป็นการตัดสินของผู้ดูแลทะเบียนลูกค้า (เช่นเรื่องเครดิต) ถ้าจำเป็นต้องรับใบนี้จริง ต้องให้เขาปลดสถานะระงับก่อน — ไม่มีใบสั่งขายถูกเปิดและไม่มีบรรทัดใดถูกเขียน`,
      };
    case CUSTOMER_IS_INACTIVE:
      return {
        heading: 'ลูกค้ารายนี้เลิกค้าขายไปแล้ว',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${CUSTOMER_IS_INACTIVE} — **คนละเรื่องกับการถูกระงับ**: รายนี้ไม่ได้มีปัญหาด้านเครดิตหรือ compliance แต่เป็นความสัมพันธ์ที่ปิดไปแล้ว (INACTIVE) ใบสั่งขายรับได้เฉพาะลูกค้าที่ ACTIVE เท่านั้น ไม่มีใบสั่งขายถูกเปิดและไม่มีบรรทัดใดถูกเขียน`,
      };
    case CUSTOMER_PO_LINE_NO_DUPLICATED:
      return {
        heading: 'เลขบรรทัด PO ของลูกค้าซ้ำกันเองในใบนี้',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${CUSTOMER_PO_LINE_NO_DUPLICATED} — เลขบรรทัดคือสิ่งที่ลูกค้าใช้อ้างบรรทัดนั้นกลับมาหาเรา สองบรรทัดที่ถือเลขเดียวกันจึงอ้างไม่ได้ว่าหมายถึงบรรทัดไหน แก้เลขบรรทัดที่ซ้ำให้ต่างกันแล้วส่งใหม่ — สิ่งที่กรอกไว้ยังอยู่ครบ`,
      };
    case SALES_ORDER_HAS_NO_LINES:
      return {
        heading: 'ใบนี้ไม่มีบรรทัดเลย',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${SALES_ORDER_HAS_NO_LINES} — ใบสั่งขายที่ไม่มีบรรทัดไม่ได้สั่งอะไร กล่องนี้กันไว้ด้วยการปิดปุ่มบันทึกอยู่แล้ว การที่คำขอไปถึงเซิร์ฟเวอร์จึงเป็นบั๊ก — แจ้งผู้ดูแลระบบ`,
      };
    case PRODUCT_NOT_ACTIVE:
      return {
        heading: 'สินค้าในบรรทัดยังไม่พร้อมขาย',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${PRODUCT_NOT_ACTIVE} — มีสินค้ารหัสนี้อยู่ แต่ยังไม่ผ่านอนุมัติหรือถูกเลิกใช้ไปแล้ว รับคำสั่งซื้อของสินค้าที่ยังไม่ ACTIVE ไม่ได้ ตรวจรหัสสินค้าอีกครั้งจากหน้า "ข้อมูลสินค้า (Product Master)"`,
      };
    case CONFIRMER_MUST_DIFFER_FROM_CREATOR:
      return {
        heading: 'ผู้ยืนยันต้องไม่ใช่ผู้เปิดใบ',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${CONFIRMER_MUST_DIFFER_FROM_CREATOR} — **ไม่ใช่เรื่องสิทธิ์ไม่พอ** คุณถือ ${SALES_MODULE} + EDIT ครบแล้ว แต่ใบนี้คุณเป็นผู้เปิดเอง การแบ่งแยกหน้าที่ (D-010) จึงให้คนอื่นเป็นผู้ยืนยัน — ขอสิทธิ์เพิ่มไม่ช่วยอะไร ต้องให้เพื่อนร่วมงานอีกคนกดยืนยัน **ใบนี้ยังอยู่ที่สถานะเดิม**`,
      };
    case SALES_ORDER_NOT_REVISABLE:
      return {
        heading: 'ใบเดิมเลื่อนสถานะไปแล้วระหว่างที่ยังไม่ได้กดส่ง',
        text: `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${SALES_ORDER_NOT_REVISABLE} — Customer PO นี้เคยรับเข้าเป็นใบสั่งขายไว้แล้ว แต่ใบเดิมเลื่อนพ้น DRAFT/CONFIRMED ไปแล้ว (มีคนวางแผนผลิตหรือส่งของบางส่วนไปแล้ว) จึงแก้ด้วยการยกฉบับ revision ไม่ได้อีก **ไม่ใช่เรื่องสิทธิ์และไม่ใช่บั๊ก** — ค้นเลข PO นี้ในหน้ารายการเพื่อดูสถานะจริงของใบเดิมก่อนตัดสินใจว่าจะทำอย่างไรต่อ ไม่มีใบสั่งขายใบใดถูกเปิดและไม่มีบรรทัดใดถูกเขียนหรือถูกแก้`,
      };
    default:
      return null;
  }
}

/**
 * `409` ที่ไม่ใช่กฎที่ตั้งชื่อไว้ = **การปฏิเสธ transition**
 *
 * contract ของกลุ่มนี้ไม่ได้ตั้งชื่อรหัสกฎให้การปฏิเสธนี้ มันสัญญาแค่ว่า `409` จะพา
 * `details.current_status` มาด้วย — ซึ่งเพียงพอและเป็นสิ่งที่ผู้ใช้ต้องรู้จริง ๆ
 * (ใบนี้ **อยู่ที่ไหน** จึงกดไม่ได้) การเดารหัสกฎขึ้นมาเองจะเป็นข้อความที่ไม่มีวันแสดง
 */
function conflictCopy(currentStatus: string | null): FailureCopy {
  return {
    heading:
      currentStatus === null
        ? 'สถานะปัจจุบันของใบนี้ไม่รับสิ่งที่กด'
        : `ใบนี้อยู่ที่ ${salesOrderStatusLabel(currentStatus)} แล้ว`,
    text: `เซิร์ฟเวอร์ตอบ 409 —${
      currentStatus === null
        ? ''
        : ` สถานะที่เก็บอยู่จริงคือ ${salesOrderStatusLabel(currentStatus)} ซึ่ง`
    } lifecycle ไม่มีเส้นทางจากตรงนั้นไปยังสิ่งที่กด สาเหตุที่พบบ่อยที่สุดคือมีคนกดไปก่อนแล้วระหว่างที่หน้าจอนี้เปิดค้างอยู่ ส่วนใบที่วางแผนผลิตหรือส่งของไปแล้วยกเลิกไม่ได้เลย โหลดรายการใหม่เพื่อดูสถานะจริงก่อนตัดสินใจ — **การกดซ้ำจะได้คำตอบเดิม** ใบนี้ยังอยู่ในสถานะเดิมและไม่มีแถว audit ถูกเขียน`,
  };
}

/**
 * ข้อความประจำแต่ละสถานะ — แจกแจงครบโดยไม่มี `default` เพื่อให้ TypeScript เป็นผู้
 * พิสูจน์ว่าไม่มีสถานะไหนตกหล่นเมื่อ client เพิ่มกรณีใหม่
 */
function failureCopy(
  failure: SalesOrderFailure,
  context: SalesOrderFailureContext,
): FailureCopy {
  const writing = isWriteContext(context);
  const nothingChanged = nothingChangedText(context);
  const currentStatus = currentStatusFromFailure(failure);

  switch (failure.status) {
    case 'unauthenticated':
      return {
        heading: 'ต้องเข้าสู่ระบบก่อนจึงจะใช้หน้าจอนี้ได้',
        text: 'เซิร์ฟเวอร์ตอบ 401 — เซสชันหมดอายุหรือถูกยกเลิกไปแล้ว token ที่ถืออยู่จึงถูกล้างทิ้งและต้องเข้าสู่ระบบใหม่ (D-049)',
      };
    case 'forbidden':
      return (
        ruleCopy(failure.error.rule) ?? {
          heading: 'สิทธิ์ชุดนี้ไม่ครอบคลุมคำขอนี้',
          text: `เซิร์ฟเวอร์ตอบ 403 — คำขอนี้ต้องการโมดูล ${SALES_MODULE} ในระดับที่สูงกว่าที่แผนกของคุณถืออยู่ ขอสิทธิ์เพิ่มที่ตารางสิทธิ์ตามแผนก${nothingChanged}`,
        }
      );
    case 'not-found':
      return {
        heading: 'ไม่พบใบสั่งขายที่คำขอนี้อ้างถึง',
        text: `เซิร์ฟเวอร์ตอบ 404 — ใบนี้ไม่มีอยู่แล้ว หรืออยู่ในโรงงานนอกขอบเขตของคุณ (สองกรณีนี้ตอบเหมือนกันโดยตั้งใจ ไม่งั้นคนที่ไซต์หนึ่งจะไล่เดาได้ว่าอีกไซต์ขายอะไรให้ใครอยู่) โหลดรายการใหม่แล้วลองอีกครั้ง${nothingChanged}`,
      };
    case 'conflict':
      return ruleCopy(failure.error.rule) ?? conflictCopy(currentStatus);
    case 'rule-violation':
      return (
        ruleCopy(failure.error.rule) ?? {
          heading: 'คำขอนี้ติดกฎทางธุรกิจ',
          text: `เซิร์ฟเวอร์ตอบ 422 พร้อมรหัสกฎที่ชน — ไม่ใช่ข้อผิดพลาดของระบบ แต่เป็นเงื่อนไขที่ต้องแก้ก่อน${nothingChanged}`,
        }
      );
    case 'bad-request':
      return (
        ruleCopy(failure.error.rule) ?? {
          heading: 'คำขอนี้ถูกปฏิเสธว่าไม่ถูกต้อง',
          text: `เซิร์ฟเวอร์ตอบ 400 — ข้อมูลที่ส่งไปไม่ตรงรูปแบบที่ API รับ (เช่น เลข PO ของลูกค้ายาวเกิน ${CUSTOMER_PO_NUMBER_MAX_LENGTH} ตัวอักษร)${nothingChanged}`,
        }
      );
    case 'server-error':
      return {
        heading: `เซิร์ฟเวอร์ตอบ ${failure.httpStatus}`,
        text: writing
          ? 'คำขอไปถึงเซิร์ฟเวอร์แล้วแต่ทำงานไม่สำเร็จ และ **ไม่มีอะไรยืนยันว่าข้อมูลถูกเปลี่ยนหรือไม่** — โหลดรายการใหม่เพื่อดูสถานะที่เก็บอยู่จริงก่อนลองอีกครั้ง'
          : 'คำขอไปถึงเซิร์ฟเวอร์แล้วแต่ทำงานไม่สำเร็จ ยังไม่มีข้อมูลจริงมาแสดง',
      };
    case 'network-error':
      return {
        heading: 'ติดต่อเซิร์ฟเวอร์ไม่ได้',
        text: writing
          ? `${failure.detail} — ไม่มีอะไรยืนยันว่าคำขอไปถึงเซิร์ฟเวอร์หรือไม่ โหลดรายการใหม่เพื่อดูสถานะที่เก็บอยู่จริงก่อนลองอีกครั้ง`
          : `${failure.detail} — หน้าจอนี้จึงไม่มีข้อมูลจะแสดง และจะไม่เดาขึ้นมาเอง`,
      };
    case 'invalid-response':
      return {
        heading: 'ข้อมูลจากเซิร์ฟเวอร์ผิดรูปแบบ',
        text: 'หน้าจอปฏิเสธที่จะแสดงเอกสารที่อ่านได้ไม่ครบ — ใบสั่งขายที่ขาดไปหนึ่งบรรทัดคือคำสั่งซื้อที่หน้าจอบอกว่าลูกค้าสั่งน้อยกว่าที่เขาสั่งจริง แล้วของที่ขาดไปจะไม่มีใครผลิตและไม่มีใครส่ง',
      };
    case 'cancelled':
      return {
        heading: 'ยกเลิกการเรียกข้อมูลแล้ว',
        text: 'คำขอถูกยกเลิกก่อนได้รับคำตอบ',
      };
  }
}

function envelopeOf(failure: SalesOrderFailure): ApiErrorEnvelope | null {
  return 'error' in failure ? failure.error : null;
}

export interface SalesOrderFailureNoticeProps {
  readonly failure: SalesOrderFailure;
  readonly context: SalesOrderFailureContext;
  readonly onRetry?: () => void;
}

export function SalesOrderFailureNotice({
  failure,
  context,
  onRetry,
}: SalesOrderFailureNoticeProps) {
  const copy = failureCopy(failure, context);
  const envelope = envelopeOf(failure);
  const rule = ruleFromFailure(failure);
  const serverMessage = envelope === null ? null : envelope.message;
  // `409` และ `422` เป็นคำตอบที่ **ผู้ใช้จัดการต่อเองได้** (ใช้เลขอื่น แก้เลขบรรทัด
  // โหลดใหม่ หรือให้เพื่อนร่วมงานกดยืนยัน) ต่างจากความล้มเหลวที่เหลือซึ่งเขาทำอะไร
  // ไม่ได้เลย
  const refusedByRule =
    failure.status === 'rule-violation' || failure.status === 'conflict';

  return (
    <div
      className="cap-notice"
      data-testid="so-failure"
      data-failure={failure.status}
      data-context={context}
      data-rule={rule ?? ''}
      role="status"
    >
      <StatusBadge tone={refusedByRule ? 'warning' : 'danger'}>
        {refusedByRule ? 'ติดกฎทางธุรกิจ' : 'ทำรายการไม่สำเร็จ'}
      </StatusBadge>
      <h3 className="cap-notice__title">{copy.heading}</h3>
      <p className="cap-notice__text">{copy.text}</p>

      {rule === null ? null : (
        <p className="cap-notice__text">
          กฎที่ชน:{' '}
          <code className="cap-table__code" data-testid="so-rule">
            {rule}
          </code>
        </p>
      )}

      {serverMessage === null ? null : (
        <p className="cap-notice__note" data-testid="so-failure-message">
          ข้อความจากเซิร์ฟเวอร์: {serverMessage}
        </p>
      )}

      {onRetry === undefined ? null : (
        <div className="cap-notice__actions">
          <button type="button" className="cap-button cap-button--ghost" onClick={onRetry}>
            ลองอีกครั้ง
          </button>
        </div>
      )}
    </div>
  );
}

/* ------------------------------------------------- D-107 ข้อ 2 — ref1..ref6 -- */

/**
 * ref1..ref6 ของบรรทัดหนึ่งบรรทัด — heading เป็น `refN` ดิบเสมอ (ไม่มีความหมาย
 * ตายตัวติดกับตำแหน่งใดเลย) และค่าที่ไม่มีแสดงเป็น "—" ที่มองเห็นได้จริง ไม่ใช่
 * ช่องว่างเปล่า ๆ ที่อ่านไม่ออกว่าเป็น "ไม่มีค่า" หรือ "ยังโหลดไม่เสร็จ"
 */
function SalesOrderLineRefs({ line }: { readonly line: SalesOrderLine }) {
  return (
    <span className="cap-line-refs" data-testid={`so-line-refs-${line.customer_po_line_no}`}>
      {salesOrderLineRefs(line).map((ref) => (
        <span
          key={ref.heading}
          className="cap-line-refs__item"
          data-testid={`so-line-ref-${line.customer_po_line_no}-${ref.heading}`}
        >
          {' '}
          <span className="cap-table__muted">{ref.heading}:</span>{' '}
          {ref.value === null ? (
            <span className="cap-table__muted" aria-label={`${ref.heading} ไม่มีค่า`}>
              —
            </span>
          ) : (
            ref.value
          )}
        </span>
      ))}
    </span>
  );
}

/* --------------------------------------- D-107 ข้อ 4 — Excel spreadsheet -- */

/**
 * ความล้มเหลวของ "ดาวน์โหลดฟอร์ม" — เส้นนี้ตอบได้แค่ 401/403/5xx/เครือข่าย/ยกเลิก
 *
 * `export` เพราะปุ่มดาวน์โหลดย้ายไปอยู่ที่ `SalesOrderReceivePage.tsx` แล้ว
 * (D-116 ข้อ 6) — สำเนาข้อความความล้มเหลวยังเป็นตัวเดียวกัน ไม่ใช่การก็อปสอง
 */
export function TemplateDownloadFailureNotice({
  failure,
  onRetry,
}: {
  readonly failure: SalesOrderFailure;
  readonly onRetry: () => void;
}) {
  const message =
    failure.status === 'unauthenticated'
      ? 'ต้องเข้าสู่ระบบก่อนจึงจะดาวน์โหลดฟอร์มนี้ได้'
      : failure.status === 'forbidden'
        ? `ต้องมีสิทธิ์ ${SALES_MODULE} + VIEW จึงจะดาวน์โหลดฟอร์มนี้ได้`
        : failure.status === 'network-error'
          ? failure.detail
          : failure.status === 'cancelled'
            ? 'ยกเลิกการดาวน์โหลดแล้ว'
            : 'เซิร์ฟเวอร์ทำงานไม่สำเร็จ ลองใหม่อีกครั้ง';

  return (
    <div
      className="cap-notice"
      data-testid="so-import-template-failure"
      data-failure={failure.status}
      role="status"
    >
      <StatusBadge tone="danger">ดาวน์โหลดฟอร์มไม่สำเร็จ</StatusBadge>
      <p className="cap-notice__text">{message}</p>
      <div className="cap-notice__actions">
        <button type="button" className="cap-button cap-button--ghost" onClick={onRetry}>
          ลองอีกครั้ง
        </button>
      </div>
    </div>
  );
}

/**
 * ความล้มเหลวของ "อัปโหลดไฟล์" (พรีวิวหรือส่งจริง) — headline ของ Work Order นี้คือ
 * 422 ที่ชี้แถวและคอลัมน์ (`spreadsheetImportFailureLocation`) ต้องแสดงแถว/คอลัมน์
 * นั้นให้เห็นจริง ไม่ยุบรวมเป็น "อัปโหลดไม่สำเร็จ" เฉย ๆ — สำเนาที่เซิร์ฟเวอร์ส่งมา
 * (`error.message`) แสดงควบคู่เสมอเพราะเป็นข้อความที่บอกสาเหตุจริงในภาษาที่ผู้ใช้
 * ต้องแก้
 *
 * `export` เพราะ `SalesOrderReceivePage.tsx` ใช้ตัวเดียวกันทั้งกับพรีวิว (D-116
 * ข้อ 5) และผลส่งจริง — สำเนาข้อความความล้มเหลวเป็นตัวเดียวกัน ไม่ใช่การก็อปสอง
 */
export function ImportSpreadsheetFailureNotice({
  failure,
}: {
  readonly failure: SalesOrderFailure;
}) {
  const envelope = envelopeOf(failure);
  const location = spreadsheetImportFailureLocation(failure);
  const message =
    envelope?.message ??
    (failure.status === 'unauthenticated'
      ? 'ต้องเข้าสู่ระบบก่อนจึงจะอัปโหลดได้'
      : failure.status === 'network-error'
        ? failure.detail
        : failure.status === 'cancelled'
          ? 'ยกเลิกการอัปโหลดแล้ว'
          : 'อัปโหลดไม่สำเร็จ');

  return (
    <div
      className="cap-notice"
      data-testid="so-import-failure"
      data-failure={failure.status}
      role="status"
    >
      <StatusBadge tone={failure.status === 'rule-violation' ? 'warning' : 'danger'}>
        อัปโหลดไม่สำเร็จ
      </StatusBadge>

      {location.row === null || location.column === null ? null : (
        <p className="cap-notice__text" data-testid="so-import-failure-location">
          แถวที่ <strong data-testid="so-import-failure-row">{location.row}</strong> คอลัมน์{' '}
          <code className="cap-table__code" data-testid="so-import-failure-column">
            {location.column}
          </code>
        </p>
      )}

      <p className="cap-notice__note" data-testid="so-import-failure-message">
        {message}
      </p>
    </div>
  );
}

/**
 * สามคำตอบของ D-092 (`outcome`) ในคำของเซิร์ฟเวอร์เอง — ไม่ re-derive จากคีย์อื่น
 *
 * `export` เพราะ `SalesOrderReceivePage.tsx` ส่งผ่าน `POST /v1/sales-orders/import`
 * เสมอแล้ว (D-116 ข้อ 9) ทั้งใบที่กรอกมือและใบที่มาจากไฟล์ upload คำตอบจึงมาถึงที่นี่
 * (`handleReceived`) หลังพากลับหน้ารายการเช่นกัน — ไม่ใช่แค่ตอน upload บนหน้านี้
 */
export function ImportSpreadsheetResultNotice({
  result,
}: {
  readonly result: CustomerPoImportResult;
}) {
  return (
    <div
      className="cap-notice"
      data-testid="so-import-result"
      data-outcome={result.outcome}
      role="status"
    >
      <StatusBadge tone={customerPoImportOutcomeTone(result.outcome)}>
        {customerPoImportOutcomeLabel(result.outcome)}
      </StatusBadge>
      <h2 className="cap-notice__title">
        ใบสั่งขาย {result.sales_order.so_number} — ลูกค้าอ้างใบสั่งซื้อเลข{' '}
        {result.customer_po_number}
      </h2>
      <p className="cap-notice__text">{customerPoImportOutcomeSummary(result.outcome)}</p>
      <ul data-testid="so-import-result-lines">
        {result.sales_order.lines.map((line) => (
          <li className="cap-notice__text" key={line.customer_po_line_no}>
            {line.customer_po_line_no} — {line.product_code} {line.quantity}{' '}
            {line.uom_code}
            <SalesOrderLineRefs line={line} />
          </li>
        ))}
      </ul>
    </div>
  );
}

/**
 * D-116 ข้อ 6 — สิทธิ์ชุดนี้ไม่มี `can_create` จึงไม่เปิดฟอร์มรับใบให้ แม้ URL จะพา
 * มาที่ `?view=receive` ตรง ๆ ก็ตาม — ลอกแบบ `CreateNotOfferedNotice` ของ
 * `ProductMasterScreen` เป๊ะ (ด่านจริงยังเป็นเซิร์ฟเวอร์เสมอ นี่แค่ไม่เปิดฟอร์ม)
 */
function ReceiveNotOfferedNotice() {
  return (
    <div className="cap-page">
      <div className="cap-notice" data-testid="so-receive-unavailable" role="status">
        <StatusBadge tone="warning">ไม่ได้เปิดฟอร์มให้</StatusBadge>
        <h1 className="cap-notice__title">สิทธิ์ชุดนี้ยังรับใบสั่งซื้อของลูกค้าไม่ได้</h1>
        <p className="cap-notice__text">
          สิทธิ์ที่เซิร์ฟเวอร์ส่งมาไม่มี flag <code className="cap-table__code">can_create</code>{' '}
          ของโมดูล <code className="cap-table__code">{SALES_MODULE}</code> หน้านี้จึงไม่เปิดฟอร์มให้
          กรอก
        </p>
        <p className="cap-notice__note">
          การไม่เปิดฟอร์มเป็นเพียง UX เพื่อไม่ให้กรอกงานที่จะถูกปฏิเสธตอนบันทึก —
          ผู้ตัดสินจริงคือ backend ทุกคำขอเสมอ
        </p>
      </div>
    </div>
  );
}

/** crumb ท้ายสุดที่หน้ารับใบ contribute เอง — แนวเดียวกับ `ProductMasterScreen` (D-107 ข้อ 6) */
const RECEIVE_TRAILING_CRUMBS: readonly Breadcrumb[] = [{ label: 'รับใบสั่งซื้อของลูกค้า' }];
const LIST_TRAILING_CRUMBS: readonly Breadcrumb[] = [];

/* --------------------------------------------------------------- หน้าจอ -- */

export interface SalesOrderScreenProps {
  readonly permissions: PermissionsState;
  readonly apiBaseUrl: string;
  /** inject ได้เพื่อการทดสอบ — production ใช้ `fetch` ของเบราว์เซอร์ */
  readonly fetchImpl?: typeof fetch;
}

type OrdersState =
  | { readonly status: 'loading' }
  | { readonly status: 'ready'; readonly page: SalesOrderListPage }
  | SalesOrderFailure;

/**
 * หน่วงก่อนส่งคำค้นไปเซิร์ฟเวอร์ (D-118 ข้อ 2) — ทุกการกดแป้นไม่ใช่ทุกคำขอ
 *
 * การค้นหาย้ายไปฝั่งเซิร์ฟเวอร์แล้ว ทุกตัวอักษรที่พิมพ์จึงเป็นคำขอได้ถ้าไม่หน่วง —
 * และคำขอที่ตอบกลับมาช้ากว่าคำค้นล่าสุดต้องถูกทิ้ง ไม่ใช่เขียนทับตารางด้วยผลของคำค้น
 * ที่ผู้ใช้เลิกพิมพ์ไปแล้ว (จัดการด้วย `AbortController` + ธง `active` ใน effect)
 */
const SEARCH_DEBOUNCE_MS = 250;

/**
 * กองของ cursor และการเลือก **ที่ผูกกับตัวกรองชุดที่มันเกิดมา**
 *
 * `key` คือลายนิ้วมือของตัวกรอง (+ หน้าที่กำลังดู สำหรับการเลือก) ตอนที่ค่านั้นถูกตั้ง
 * และค่าจะถูกอ่านออกมาใช้ **เฉพาะเมื่อ `key` ยังตรงกับของตอนนี้** — นี่คือวิธีที่
 * "เปลี่ยนตัวกรองแล้วกลับหน้าแรกและการเลือกล้าง" เป็นจริง **โดยไม่ต้องมี effect ที่ไป
 * ล้างค่าให้ทีหลัง**: effect ที่ล้างทีหลังจะยิงคำขอหนึ่งรอบด้วยตัวกรองใหม่บวก cursor
 * ของหน้าเก่าไปก่อน แล้วจึงล้าง — ซึ่งเป็นหน้าที่ผู้ใช้ไม่ได้ขอและไม่มีอยู่จริง
 *
 * **การเลือกที่ค้างจากตัวกรองเก่าคือการ export ของที่มองไม่เห็นอยู่บนจอ** (D-118 ข้อ 6)
 * จึงต้องล้างทั้งตอนเปลี่ยนตัวกรองและตอนเปลี่ยนหน้า
 */
interface ScopedPaging {
  readonly key: string;
  readonly cursors: readonly string[];
}

interface ScopedSelection {
  readonly key: string;
  readonly ids: readonly string[];
  /** ผู้ใช้กด "เลือกทั้งหมด N รายการที่ตรงตัวกรอง" — Export ส่ง **ตัวกรอง** ไม่ใช่ id */
  readonly allMatching: boolean;
}

const NO_CURSORS: readonly string[] = [];
const NO_IDS: readonly string[] = [];

/**
 * ใบที่ผู้ใช้กดดูบรรทัด — **หนึ่งใบเท่านั้นในแต่ละครั้ง**
 *
 * รูปนี้เป็นเหตุผลที่ contract ตัดบรรทัดออกจากรายการได้ตั้งแต่แรก: คนอ่านทีละใบ
 */
type DetailState =
  | { readonly status: 'loading'; readonly soId: string }
  | { readonly status: 'ready'; readonly order: SalesOrder }
  | { readonly status: 'failed'; readonly soId: string; readonly failure: SalesOrderFailure };

/**
 * คำขอที่กำลังเดินทางอยู่ — ใช้ปิดปุ่มทั้งหน้าจอระหว่างนั้น
 *
 * ไม่มีกรณี `'create'` อีกต่อไป — สถานะ pending ของการรับใบเป็นของ
 * `SalesOrderReceivePage.tsx` เอง (D-116 ข้อ 3 และ 6) เหลือแค่ transition รายแถว
 */
type Pending = { readonly kind: SalesOrderTransition; readonly soId: string };

/** ผลของปุ่ม lifecycle ที่ผูกกับแถวที่กด — ทั้งสำเร็จและไม่สำเร็จอยู่ที่แถวนั้น */
interface ActionOutcome {
  readonly soId: string;
  readonly transition: SalesOrderTransition;
  readonly failure: SalesOrderFailure | null;
  readonly order: SalesOrderSummary | null;
}

export function SalesOrderScreen({
  permissions,
  apiBaseUrl,
  fetchImpl,
}: SalesOrderScreenProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const setTrailingCrumbs = useTrailingCrumbs();
  const view = resolveSalesOrdersView(searchParams);

  const canCreate = can(permissions, SALES_MODULE, 'CREATE');
  const canEdit = can(permissions, SALES_MODULE, 'EDIT');

  const [orders, setOrders] = useState<OrdersState>({ status: 'loading' });
  const [reloadToken, setReloadToken] = useState(0);
  const [pending, setPending] = useState<Pending | null>(null);

  /**
   * **ตัวกรองทั้งหกอยู่ใน URL ไม่ใช่ใน state** (D-118 ข้อ 2) — refresh ได้ ส่งลิงก์ต่อได้
   * และปุ่ม back ย้อนตัวกรองได้ ส่วน `?view=receive` ที่อยู่ใน URL เดียวกันไม่ถูกแตะเลย
   */
  const filters = resolveSalesOrderListFilters(searchParams);
  const pageSize = resolveSalesOrderPageSize(searchParams);
  /**
   * ลายนิ้วมือของ "สิ่งที่กำลังดู" — ตัวกรอง + จำนวนแถวต่อหน้า **โดยไม่มี `view`**
   *
   * ประกอบจาก `URLSearchParams` เปล่าโดยตั้งใจ: การสลับไป `?view=receive` แล้วกลับมา
   * ต้องไม่ถูกนับว่าเป็น "ตัวกรองเปลี่ยน" ซึ่งจะเด้งผู้ใช้กลับหน้าแรกของรายการ
   */
  const filterKey = salesOrderListSearch(new URLSearchParams(), filters, pageSize);

  const [paging, setPaging] = useState<ScopedPaging>({ key: filterKey, cursors: NO_CURSORS });
  const cursors = paging.key === filterKey ? paging.cursors : NO_CURSORS;
  /** cursor ของหน้าที่กำลังดู — `undefined` คือหน้าแรก (ไม่ใช่ cursor ว่าง) */
  const cursor = cursors.length === 0 ? undefined : cursors[cursors.length - 1];

  const selectionKey = `${filterKey}|${cursor ?? ''}`;
  const [selection, setSelection] = useState<ScopedSelection>({
    key: selectionKey,
    ids: NO_IDS,
    allMatching: false,
  });
  const selectedIds = selection.key === selectionKey ? selection.ids : NO_IDS;
  const allMatchingSelected = selection.key === selectionKey && selection.allMatching;

  /** ช่องค้นหาที่ผู้ใช้กำลังพิมพ์ — เขียนลง URL หลังหน่วง ไม่ใช่ทุกตัวอักษร */
  const [searchDraft, setSearchDraft] = useState(filters.q);

  const [exportPending, setExportPending] = useState(false);
  const [exportFailure, setExportFailure] = useState<SalesOrderFailure | null>(null);

  const [detail, setDetail] = useState<DetailState | null>(null);

  /**
   * ผลของการส่ง Customer PO เข้าระบบจาก `SalesOrderReceivePage` — **ทั้งกรอกมือและ
   * upload มาถึงที่นี่ทางเดียวกัน** เพราะทั้งคู่ส่งผ่าน `POST /v1/sales-orders/import`
   * แล้ว (D-116 ข้อ 9) จึงมีแค่สามผลที่เป็นไปได้ (`CustomerPoImportResult.outcome`)
   * ไม่ใช่แค่ "สร้างสำเร็จ" เหมือนก่อนหน้านี้
   */
  const [receivedResult, setReceivedResult] = useState<CustomerPoImportResult | null>(null);

  const [actionOutcome, setActionOutcome] = useState<ActionOutcome | null>(null);

  // สับหน้าย่อยเป็น search param ไม่ใช่ nested route (D-116 ข้อ 3) จึงต้องบอก
  // `DesktopShell` เองว่าตอนนี้อยู่ลึกแค่ไหน — แนวเดียวกับ `ProductMasterScreen`
  useEffect(() => {
    setTrailingCrumbs(view.kind === 'receive' ? RECEIVE_TRAILING_CRUMBS : LIST_TRAILING_CRUMBS);
  }, [view.kind, setTrailingCrumbs]);

  /**
   * เขียนตัวกรองชุดใหม่ลง URL — **จุดเดียวที่ตัวกรองเปลี่ยน**
   *
   * `replace` เพราะการพิมพ์คำค้นหนึ่งครั้งไม่ควรฝังรายการ history ไว้หนึ่งอันต่อหนึ่งคำ
   * ที่หน่วงจบ — ปุ่ม back จะกลายเป็นปุ่มลบตัวอักษรทีละตัว
   *
   * อ่านตัวกรองเดิมจาก `prev` ที่ router ส่งเข้ามา ไม่ใช่จาก closure: สองการเปลี่ยนที่
   * เกิดชิดกัน (พิมพ์แล้วเปลี่ยนสถานะทันที) จะทับกันถ้าอ่านจากค่าที่ค้างอยู่ใน render เก่า
   */
  const applyFilters = (
    change: (current: SalesOrderListFilters) => SalesOrderListFilters,
    nextPageSize?: number,
  ) => {
    setSearchParams(
      (previous) =>
        new URLSearchParams(
          salesOrderListSearch(
            previous,
            change(resolveSalesOrderListFilters(previous)),
            nextPageSize ?? resolveSalesOrderPageSize(previous),
          ),
        ),
      { replace: true },
    );
  };

  // คำค้นเดินทางไปเซิร์ฟเวอร์หลังผู้ใช้หยุดพิมพ์ — ไม่ใช่ทุกตัวอักษร (D-118 ข้อ 2)
  useEffect(() => {
    if (searchDraft === filters.q) {
      return;
    }
    const timer = setTimeout(() => {
      applyFilters((current) => ({ ...current, q: searchDraft }));
    }, SEARCH_DEBOUNCE_MS);
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchDraft, filters.q]);

  const createdRangeReversed = isReversedDateRange(filters.createdFrom, filters.createdTo);
  const deliveryRangeReversed = isReversedDateRange(
    filters.deliveryFrom,
    filters.deliveryTo,
  );
  const filtersRequestable = areSalesOrderListFiltersRequestable(filters);

  // ปุ่มล้างตัวกรอง (ผู้ใช้สั่ง 2026-10-05) — แสดงเมื่อมีตัวกรองใน URL หรือคำค้นที่
  // ยังพิมพ์ค้างใน `searchDraft` ที่ยังไม่ถูกเขียนลง URL (debounce ยังไม่จบ)
  const hasActiveFilters = hasAnySalesOrderListFilter(filters) || searchDraft.trim() !== '';

  const resetFilters = () => {
    setSearchDraft('');
    applyFilters(() => EMPTY_SALES_ORDER_LIST_FILTERS);
  };

  useEffect(() => {
    // **ไม่ยิงคำขอที่รู้ว่าจะโดน 422** — ช่วงกลับหัวถูกบอกที่ฟอร์ม และตารางที่โหลดไว้
    // ก่อนหน้ายังอยู่ ไม่กระพริบเป็นความล้มเหลวเพราะผู้ใช้พิมพ์วันที่สองช่องสลับกัน
    if (!filtersRequestable) {
      return;
    }

    const controller = new AbortController();
    let active = true;

    // ระหว่างโหลดซ้ำหลังกดปุ่มสำเร็จ **ตารางเดิมยังอยู่** ไม่กระพริบเป็นหน้าว่าง
    setOrders((previous) => (previous.status === 'ready' ? previous : { status: 'loading' }));

    const options = { apiBaseUrl, fetchImpl, signal: controller.signal };

    void fetchSalesOrders(
      {
        ...toSalesOrderListQueryFilters(filters),
        limit: pageSize,
        ...(cursor === undefined ? {} : { cursor }),
      },
      options,
    ).then((result) => {
      if (!active || result.status === 'cancelled') {
        return;
      }
      setOrders(result.status === 'ready' ? { status: 'ready', page: result.page } : result);
    });

    return () => {
      active = false;
      controller.abort();
    };
    // `filterKey` ครอบตัวกรองทั้งหกและจำนวนแถวต่อหน้าไว้เป็นสตริงเดียว — ใส่ `filters`
    // (object ใหม่ทุก render) ลงไปตรง ๆ จะยิงคำขอใหม่ทุกครั้งที่หน้าจอเรนเดอร์
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiBaseUrl, fetchImpl, reloadToken, filterKey, cursor, filtersRequestable]);

  /**
   * ดูบรรทัดของใบเดียว — `GET /{so_id}` **ตอนที่ผู้ใช้กดดู** ไม่ใช่ตอนโหลดรายการ
   *
   * นี่คือครึ่งที่สองของการตัดบรรทัดออกจากรายการ: รายการเบาเพราะไม่มีบรรทัด และ
   * บรรทัดมาถึงเมื่อมีคนต้องการอ่านมันจริง ๆ **หนึ่งคำขอต่อหนึ่งใบที่เปิดดู** ไม่ใช่
   * หนึ่งคำขอต่อทุกแถวในตาราง
   */
  const openDetail = async (order: SalesOrderSummary) => {
    setDetail({ status: 'loading', soId: order.so_id });
    const result = await fetchSalesOrder(order.so_id, { apiBaseUrl, fetchImpl });
    if (result.status === 'cancelled') {
      return;
    }
    setDetail(
      result.status === 'ready'
        ? { status: 'ready', order: result.order }
        : { status: 'failed', soId: order.so_id, failure: result },
    );
  };

  /**
   * `SalesOrderReceivePage` เพิ่งส่ง Customer PO เข้าระบบสำเร็จผ่าน `/import` —
   * โหลดรายการใหม่ ล้างคำค้น (ไม่งั้นใบที่เพิ่งรับเข้าซึ่งมักไม่ตรงกับคำค้นเดิมจะถูก
   * กรองออกทันที) แล้วพากลับมาที่รายการ (D-116 ข้อ 6: "พากลับหน้ารายการพร้อมใบใหม่")
   *
   * **ไม่ได้แปลว่า "สร้างใบใหม่เสมอ"** อีกต่อไป (D-116 ข้อ 9) — `result.outcome`
   * อาจเป็น `DUPLICATE_IGNORED` (พบใบเดิมทุกบรรทัด ไม่มีอะไรถูกเขียน) หรือ
   * `REVISION_RAISED` (เปิดคำขอแก้ไขไว้รออนุมัติ ใบเดิมยังไม่ถูกแก้) เท่าเดิม
   * `ImportSpreadsheetResultNotice` เป็นผู้แยกสามผลนี้ออกจากกันในคำของเซิร์ฟเวอร์เอง
   */
  const handleReceived = (result: CustomerPoImportResult) => {
    setReceivedResult(result);
    setSearchDraft('');
    setReloadToken((token) => token + 1);
    // `search: ''` ล้าง **ทั้ง `view` และตัวกรองทั้งหก** — ใบที่เพิ่งรับเข้ามักไม่ตรงกับ
    // ตัวกรองที่ค้างอยู่ และหน้าที่พากลับมาแล้วไม่เห็นใบที่เพิ่งสร้าง คือหน้าที่อ่าน
    // เหมือนการรับใบไม่สำเร็จ
    navigate({ pathname, search: '' }, { replace: true });
  };

  const runTransition = async (
    order: SalesOrderSummary,
    transition: SalesOrderTransition,
  ) => {
    if (
      pending !== null ||
      !can(permissions, SALES_MODULE, salesOrderActionPermission(transition))
    ) {
      return;
    }

    setPending({ kind: transition, soId: order.so_id });
    setActionOutcome(null);

    const options = { apiBaseUrl, fetchImpl };

    let result: SalesOrderWriteResult;
    switch (transition) {
      case 'confirm':
        result = await confirmSalesOrder(order.so_id, options);
        break;
      case 'cancel':
        result = await cancelSalesOrder(order.so_id, options);
        break;
    }

    setPending(null);
    if (result.status === 'cancelled') {
      return;
    }
    if (result.status !== 'ready') {
      // **ไม่แตะรายการเลย** — คำอธิบายอยู่ที่แถวที่เขากด ไม่ใช่ลอยอยู่ท้ายหน้า
      setActionOutcome({
        soId: order.so_id,
        transition,
        failure: result,
        order: null,
      });
      return;
    }

    setActionOutcome({
      soId: order.so_id,
      transition,
      failure: null,
      order: result.order,
    });
    // สถานะใหม่มาจาก **การโหลดรายการใหม่** ไม่ใช่การแก้แถวในหน่วยความจำ
    setReloadToken((token) => token + 1);
  };

  const page = orders.status === 'ready' ? orders.page : null;
  const items: readonly SalesOrderListItem[] = page?.items ?? [];
  const total = page?.total ?? 0;
  const busy = pending !== null;
  /** ปุ่มที่เขียนได้สักปุ่มหนึ่ง — ใช้ตัดสินว่าจะขึ้นป้าย "ดูได้อย่างเดียว" ไหม */
  const canWriteAnything = canCreate || canEdit;

  /** transition ที่แถวนี้เสนอได้จริง = เส้นทางที่มีอยู่ ∩ สิทธิ์ที่ผู้ใช้ถือ */
  const offeredActions = (
    order: SalesOrderSummary,
  ): readonly SalesOrderTransition[] =>
    salesOrderLifecycleActionsFor(order.status).filter((transition) =>
      can(permissions, SALES_MODULE, salesOrderActionPermission(transition)),
    );

  const anyRowHasActions = items.some((order) => offeredActions(order).length > 0);

  /* ------------------------------------ D-118 ข้อ 1 — ก่อนหน้า/ถัดไป/จำนวนรวม -- */

  const firstRowNumber = cursors.length * pageSize + 1;
  const rowRangeLabel = salesOrderRowRangeLabel(firstRowNumber, items.length, total);
  const hasPreviousPage = cursors.length > 0;
  const nextCursor = page?.next_cursor ?? null;

  const goToNextPage = () => {
    if (nextCursor === null) {
      return;
    }
    setPaging({ key: filterKey, cursors: [...cursors, nextCursor] });
  };

  const goToPreviousPage = () => {
    if (!hasPreviousPage) {
      return;
    }
    setPaging({ key: filterKey, cursors: cursors.slice(0, -1) });
  };

  /* ------------------------------------------- D-118 ข้อ 6 — ช่องเลือกรายใบ --- */

  const isRowSelected = (order: SalesOrderListItem): boolean =>
    allMatchingSelected || selectedIds.includes(order.so_id);

  const pageFullySelected = items.length > 0 && items.every(isRowSelected);
  const pagePartlySelected = !pageFullySelected && items.some(isRowSelected);

  const setSelectedRows = (ids: readonly string[]) => {
    setSelection({ key: selectionKey, ids, allMatching: false });
  };

  const toggleRow = (order: SalesOrderListItem) => {
    // ติ๊กหรือเอาติ๊กออกหลังกด "เลือกทั้งหมด N" = เลิกโหมดนั้น แล้วเริ่มจากแถวในหน้านี้
    const base = allMatchingSelected ? items.map((item) => item.so_id) : selectedIds;
    setSelectedRows(
      base.includes(order.so_id)
        ? base.filter((id) => id !== order.so_id)
        : [...base, order.so_id],
    );
  };

  const toggleWholePage = () => {
    setSelectedRows(pageFullySelected ? NO_IDS : items.map((item) => item.so_id));
  };

  /**
   * id ที่ Export จะส่ง — **ว่างเปล่าแปลว่า "ส่งตัวกรอง"** ไม่ใช่ "ไม่ export อะไร"
   *
   * โหมด "เลือกทั้งหมด N" จึงเป็นค่าว่างด้วย: id นับพันที่หน้าจอต้องไล่เก็บจากทุกหน้า
   * ก่อนถึงจะส่งได้ คือ N คำขอเพื่อประกอบไฟล์เดียว และจะไม่ตรงกับสิ่งที่เซิร์ฟเวอร์เห็น
   * ถ้ามีคนรับใบเพิ่มระหว่างนั้น (D-118 ข้อ 6)
   */
  const exportIds = allMatchingSelected ? NO_IDS : selectedIds;
  /** จำนวนที่ลิงก์ "เลือกทั้งหมด N" จะเสนอ — เฉพาะเมื่อเลือกครบหน้าแล้วยังมีหน้าอื่น */
  const offerSelectAllMatching =
    pageFullySelected && !allMatchingSelected && total > items.length;

  const runExport = async () => {
    if (exportPending) {
      return;
    }
    setExportPending(true);
    setExportFailure(null);

    const result = await exportSalesOrders(salesOrderExportRequest(filters, exportIds), {
      apiBaseUrl,
      fetchImpl,
    });

    setExportPending(false);
    if (result.status === 'cancelled') {
      return;
    }
    setExportFailure(result.status === 'ready' ? null : result);
  };

  // D-116 ข้อ 3 และ 6 — `?view=receive` แทนที่กล่อง `Modal` เดิมทั้งกล่อง หน้ารายการ
  // ทั้งหน้าไม่ถูกเรนเดอร์เลยขณะอยู่ในหน้าย่อยนี้ (แนวเดียวกับ `ProductMasterScreen`
  // ตอน `view.kind === 'create'`) — Modal ต้องหายไปจากหน้ารายการจริง ๆ ไม่ใช่แค่ไม่เปิด
  if (view.kind === 'receive') {
    if (!canCreate) {
      return <ReceiveNotOfferedNotice />;
    }
    return (
      <SalesOrderReceivePage
        permissions={permissions}
        apiBaseUrl={apiBaseUrl}
        fetchImpl={fetchImpl}
        onSubmitted={handleReceived}
      />
    );
  }

  return (
    <div className="cap-page" data-testid="sales-orders">
      <div className="cap-page__head">
        <div>
          <h1 className="cap-page__title">
            ใบสั่งขาย (Sales Order)
            {/*
              `WO-P2-M4-008` (D-107 ข้อ 5, Comment 4) — ย่อหน้าอธิบายย้ายเข้า (i)
              ด้วยกลไกเดียวกับ `ProductListView` **ย้าย ไม่ใช่ลบ**
            */}
            <InfoHint
              label="เกี่ยวกับรายการนี้"
              text="คำสั่งซื้อของลูกค้าที่รับเข้าระบบแล้ว — ใบสั่งซื้อของลูกค้าหนึ่งใบเท่ากับใบสั่งขายหนึ่งใบ (D-090) รายการด้านล่างแสดงเฉพาะโรงงานที่คุณมีสิทธิ์เข้าถึง และไม่แสดงบรรทัด — กด “ดูบรรทัด” ในแถวที่ต้องการ"
            />
          </h1>
        </div>
      </div>

      {!canWriteAnything ? (
        <div className="cap-notice" data-testid="so-read-only" role="status">
          <StatusBadge tone="warning">ดูได้อย่างเดียว</StatusBadge>
          <h2 className="cap-notice__title">
            สิทธิ์ชุดนี้ยังรับใบหรือขับสถานะไม่ได้{' '}
            <InfoHint
              label="ทำไมปุ่มไม่แสดง"
              text={`สิทธิ์ที่เซิร์ฟเวอร์ส่งมาไม่มี flag can_create หรือ can_edit ของโมดูล ${SALES_MODULE} ปุ่ม "รับใบสั่งซื้อของลูกค้า" และปุ่มยืนยัน/ยกเลิกในแต่ละแถวจึงไม่แสดง — รายการ ช่องค้นหา ตัวกรองทุกตัว การดูบรรทัด และ Export ยังใช้ได้ตามปกติ เพราะทั้งหมดเป็นการอ่าน`}
            />
          </h2>
        </div>
      ) : null}

      {/* --------------------------------- ค้นหา + ตัวกรอง + ปุ่มรับใบ -- */}

      <div className="cap-filters" data-testid="so-toolbar">
        <label className="cap-field">
          <span className="cap-field__label">
            ค้นหาใบสั่งขาย{' '}
            <InfoHint
              label="ค้นหาอะไรได้"
              text="เซิร์ฟเวอร์เป็นผู้ค้น (D-118 ข้อ 2) จึงหาเจอทั้งสมุดคำสั่งซื้อ ไม่ใช่แค่หน้าที่เปิดอยู่ — เทียบกับเลขที่ใบ รหัสและชื่อลูกค้า และเลข PO ของลูกค้า โดยไม่สนตัวพิมพ์และตรงที่ตำแหน่งใดก็ได้"
            />
          </span>
          <input
            className="cap-input"
            type="search"
            name="so_query"
            data-testid="so-search"
            value={searchDraft}
            autoComplete="off"
            onChange={(event) => {
              setSearchDraft(event.target.value);
            }}
          />
        </label>

        <label className="cap-field">
          <span className="cap-field__label">สถานะ</span>
          <select
            className="cap-input"
            name="status_filter"
            data-testid="so-status-filter"
            value={filters.status}
            onChange={(event) => {
              const status = event.target.value;
              applyFilters((current) => ({ ...current, status }));
            }}
          >
            <option value="">ทุกสถานะ</option>
            {SALES_ORDER_STATUS_DESCRIPTORS.map((descriptor) => (
              <option key={descriptor.code} value={descriptor.code}>
                {descriptor.label}
              </option>
            ))}
          </select>
        </label>

        {/*
          D-118 ข้อ 3 — **สองช่วงวันที่เป็นคนละคำถามกัน** "วันที่บันทึก" คือวันที่เรา
          คีย์ใบเข้าระบบ ส่วน Delivery Date คือวันที่ลูกค้าอยากได้ของ ใบเดียวกันอยู่ใน
          ช่วงหนึ่งแต่ไม่อยู่ในอีกช่วงได้ตามปกติ
        */}
        {/*
          D-120 — **ช่วงหนึ่งช่วงคือช่องเดียว ไม่ใช่สองช่องที่บังเอิญอยู่ติดกัน**
          สองช่อง `type=date` ต่อหนึ่งช่วงถูกแทนด้วย `DateRangePicker` ที่เลือกทั้ง
          "จาก" และ "ถึง" ในปฏิทินเดียว **ค่าใน URL และที่ส่งให้เซิร์ฟเวอร์ไม่เปลี่ยน**
          (`created_from/to`, `delivery_from/to`) — เปลี่ยนแค่วิธีเลือก ไม่ใช่สัญญา
        */}
        <DateRangePicker
          label="วันที่บันทึก"
          testId="so-created-range"
          from={filters.createdFrom}
          to={filters.createdTo}
          onChange={(createdFrom, createdTo) => {
            applyFilters((current) => ({ ...current, createdFrom, createdTo }));
          }}
          hint={
            <InfoHint
              label="ช่วงวันที่บันทึกคืออะไร"
              text="วันที่เราคีย์ใบสั่งขายเข้าระบบ อ่านตามปฏิทินไทย (D-055) ไม่ใช่วันที่ลูกค้าอยากได้ของ คลิกแรกคือวันเริ่ม คลิกที่สองคือวันสิ้นสุด — ปลายข้างเดียวยังมาจากลิงก์ที่ส่งต่อกันได้และแสดงเป็น “…”"
            />
          }
        />

        <DateRangePicker
          label="Delivery Date"
          testId="so-delivery-range"
          from={filters.deliveryFrom}
          to={filters.deliveryTo}
          onChange={(deliveryFrom, deliveryTo) => {
            applyFilters((current) => ({ ...current, deliveryFrom, deliveryTo }));
          }}
          hint={
            <InfoHint
              label="ช่วง Delivery Date คืออะไร"
              text="หัวใบสั่งขายไม่มีวันส่งของตัวเอง (D-118 ข้อ 3) ตัวกรองนี้จึงเก็บใบที่ “บรรทัดใดบรรทัดหนึ่ง” ต้องการของในช่วงนี้ ใบที่มีหลายบรรทัดหลายวันจะขึ้นครั้งเดียว ไม่ใช่ครั้งละบรรทัด"
            />
          }
        />

        <label className="cap-field">
          <span className="cap-field__label">
            แถวต่อหน้า{' '}
            <InfoHint
              label="จำนวนแถวต่อหน้าทำอะไร"
              text={`เปลี่ยนจำนวนใบที่ขอมาต่อหนึ่งหน้า (${SALES_ORDER_PAGE_SIZES.join('/')} ค่าเริ่มต้น ${DEFAULT_SALES_ORDER_PAGE_SIZE}) — เปลี่ยนแล้วกลับไปหน้าแรกและการเลือกที่ค้างอยู่ถูกล้าง เพราะแถวที่เลือกไว้อาจไม่อยู่บนหน้าใหม่แล้ว`}
            />
          </span>
          <select
            className="cap-input"
            name="page_size"
            data-testid="so-page-size"
            value={String(pageSize)}
            onChange={(event) => {
              applyFilters((current) => current, Number(event.target.value));
            }}
          >
            {SALES_ORDER_PAGE_SIZES.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </label>

        {hasActiveFilters ? (
          <button
            type="button"
            className="cap-button cap-button--ghost"
            data-testid="so-filters-reset"
            onClick={resetFilters}
          >
            ล้างตัวกรอง
          </button>
        ) : null}

        {/*
          D-116 ข้อ 3 และ 6 — พาไป `?view=receive` แทนการเปิดกล่อง `Modal` เดิม
          ทั้งกล่อง (ฟอร์มทั้งหมดย้ายไปอยู่ที่ `SalesOrderReceivePage.tsx` แล้ว)
          testid เดิม (`so-create-open`) คงไว้ — เทสต์ที่ตรวจการ gate สิทธิ์ที่
          ระดับ route (`DesktopShell.test.tsx`) อ้างชื่อนี้อยู่แล้วและไม่สนใจว่า
          องค์ประกอบข้างในจะเป็นปุ่มเปิด Modal หรือลิงก์
        */}
        {canCreate ? (
          <Link
            className="cap-button cap-button--primary"
            data-testid="so-create-open"
            to={{ pathname, search: receiveSalesOrderSearch(searchParams) }}
          >
            รับใบสั่งซื้อของลูกค้า
          </Link>
        ) : null}
      </div>

      {/*
        D-118 ข้อ 3 — ช่วงกลับหัวถูกบอก **ที่ฟอร์ม** และไม่มีคำขอใดออกเดินทาง
        (`filtersRequestable`) นี่เป็นข้อความสถานะ ไม่ใช่ย่อหน้าอธิบาย (D-119)
      */}
      {createdRangeReversed ? (
        <div className="cap-notice" data-testid="so-created-range-reversed" role="status">
          <StatusBadge tone="warning">ช่วงวันที่บันทึกกลับหัว</StatusBadge>
          <h2 className="cap-notice__title">
            วันที่บันทึก &quot;จาก&quot; ({filters.createdFrom}) อยู่หลัง &quot;ถึง&quot; (
            {filters.createdTo})
          </h2>
        </div>
      ) : null}

      {deliveryRangeReversed ? (
        <div className="cap-notice" data-testid="so-delivery-range-reversed" role="status">
          <StatusBadge tone="warning">ช่วง Delivery Date กลับหัว</StatusBadge>
          <h2 className="cap-notice__title">
            Delivery Date &quot;จาก&quot; ({filters.deliveryFrom}) อยู่หลัง &quot;ถึง&quot; (
            {filters.deliveryTo})
          </h2>
        </div>
      ) : null}

      {/*
        D-116 ข้อ 9 — ผลของการส่งจาก `SalesOrderReceivePage` (กรอกมือหรือ upload
        เข้าทางเดียวกันแล้วผ่าน `POST /v1/sales-orders/import`) แสดงด้วย component
        เดียวกับที่เคยแสดงผล upload บนหน้านี้ — สามคำตอบเดิมทุกประการ
      */}
      {receivedResult === null ? null : (
        <ImportSpreadsheetResultNotice result={receivedResult} />
      )}

      {/* --------------------------------------------- ผลของปุ่มที่กดสำเร็จ -- */}

      {actionOutcome?.order == null ? null : (
        <div className="cap-notice" data-testid="so-action-result" role="status">
          <StatusBadge tone="success">บันทึกแล้ว</StatusBadge>
          <h2 className="cap-notice__title">
            ใบสั่งขาย {actionOutcome.order.so_number} อยู่ที่สถานะ{' '}
            {salesOrderStatusLabel(actionOutcome.order.status)} แล้ว
          </h2>
        </div>
      )}

      {/* ------------------------------------------------------- รายการใบ -- */}

      {/*
        ช่วงกลับหัว = **ไม่มีคำขอเดินทางอยู่** ป้าย "กำลังโหลด" ตอนนั้นจะเป็นหน้าจอที่
        รอสิ่งที่ไม่มีใครขอ ค้างอยู่ตลอดไป — คำอธิบายที่ถูกคือกล่องช่วงกลับหัวข้างบน
      */}
      {orders.status === 'loading' && filtersRequestable ? (
        <div className="cap-notice" data-testid="so-loading" role="status">
          <p className="cap-notice__text">กำลังโหลดรายการใบสั่งขาย…</p>
        </div>
      ) : null}

      {orders.status !== 'loading' && orders.status !== 'ready' ? (
        <SalesOrderFailureNotice
          failure={orders}
          context="orders"
          onRetry={() => {
            setReloadToken((token) => token + 1);
          }}
        />
      ) : null}

      {/**
       * **"ยังไม่มีใบสั่งขาย" กับ "ไม่มีใบที่ตรงตัวกรอง" เป็นคนละหน้าจอกัน** ต่อให้
       * ทั้งคู่เป็นรายการว่างที่เซิร์ฟเวอร์ตอบสำเร็จเหมือนกัน: คนแรกต้องไปรับใบเข้าระบบ
       * คนที่สองต้องแก้ตัวกรองของตัวเอง — ตั้งแต่ D-118 ข้อ 2 ตัวตัดสินคือ **ตัวกรองมี
       * อะไรทำงานอยู่ไหม** ไม่ใช่การเทียบจำนวนแถวก่อน/หลังกรองฝั่งเบราว์เซอร์ (ซึ่งไม่มี
       * อยู่แล้ว)
       */}
      {orders.status === 'ready' && items.length === 0 && !hasAnySalesOrderListFilter(filters) ? (
        <div className="cap-notice" data-testid="so-empty" role="status">
          <StatusBadge tone="neutral">ยังไม่มีใบสั่งขาย</StatusBadge>
          <h2 className="cap-notice__title">ยังไม่มีใบสั่งขายในโรงงานที่คุณเข้าถึงได้</h2>
        </div>
      ) : null}

      {orders.status === 'ready' && items.length === 0 && hasAnySalesOrderListFilter(filters) ? (
        <div className="cap-notice" data-testid="so-no-match" role="status">
          <StatusBadge tone="neutral">ไม่พบใบที่ค้นหา</StatusBadge>
          <h2 className="cap-notice__title">ไม่มีใบสั่งขายที่ตรงตัวกรอง</h2>
        </div>
      ) : null}

      {/* ------------------------------------- D-118 ข้อ 5-7 — Export Excel -- */}

      {orders.status === 'ready' && items.length > 0 ? (
        <div className="cap-filters" data-testid="so-export-bar">
          <button
            type="button"
            className="cap-button cap-button--primary"
            data-testid="so-export"
            disabled={exportPending}
            onClick={() => {
              void runExport();
            }}
          >
            {exportPending ? 'กำลังสร้างไฟล์…' : salesOrderExportLabel(exportIds.length, total)}
          </button>
          <InfoHint
            label="ปุ่ม Export ส่งอะไรไป"
            text="ติ๊กใบไว้ = ส่งเฉพาะเลขใบที่ติ๊ก; ไม่ติ๊กเลยหรือกด “เลือกทั้งหมด” = ส่งตัวกรองปัจจุบันให้เซิร์ฟเวอร์เขียนทุกแถวที่ตรง ไม่ใช่เฉพาะหน้านี้ คอลัมน์ในไฟล์เรียงเหมือนตารางนี้ และไฟล์นี้ไม่ได้เปลี่ยนข้อมูลอะไรเลย"
          />

          {allMatchingSelected ? (
            <span className="cap-card__hint" data-testid="so-select-all-active">
              เลือกทั้งหมด {total} รายการที่ตรงตัวกรองแล้ว{' '}
              <button
                type="button"
                className="cap-button cap-button--ghost"
                data-testid="so-select-clear"
                onClick={() => {
                  setSelectedRows(NO_IDS);
                }}
              >
                ล้างการเลือก
              </button>
            </span>
          ) : null}

          {offerSelectAllMatching ? (
            <button
              type="button"
              className="cap-button cap-button--ghost"
              data-testid="so-select-all-matching"
              onClick={() => {
                setSelection({ key: selectionKey, ids: NO_IDS, allMatching: true });
              }}
            >
              เลือกทั้งหมด {total} รายการที่ตรงตัวกรอง
            </button>
          ) : null}
        </div>
      ) : null}

      {exportFailure === null ? null : (
        <SalesOrderFailureNotice failure={exportFailure} context="export" />
      )}

      {orders.status === 'ready' && items.length > 0 ? (
        <section className="cap-card cap-card--table" aria-label="ใบสั่งขายทั้งหมด">
          <div className="cap-card__head">
            <h2 className="cap-card__title">ใบสั่งขายทั้งหมด</h2>
            <span className="cap-card__hint" data-testid="so-row-range">
              {rowRangeLabel}
            </span>
          </div>
          <div className="cap-table-wrap">
            <table className="cap-table" data-testid="so-table">
              <caption className="cap-visually-hidden">
                ใบสั่งขายของโรงงานที่คุณเข้าถึงได้ พร้อมสถานะและปุ่มที่สถานะนั้นอนุญาต
                — บรรทัดไม่ได้มากับรายการ ต้องกดดูรายใบ
              </caption>
              <thead>
                <tr>
                  <th scope="col" className="cap-table__check">
                    {/*
                      ช่องหัวตาราง = เลือก/ยกเลิก **ทั้งหน้า** ไม่ใช่ทั้งสมุดคำสั่งซื้อ
                      (นั่นเป็นลิงก์ "เลือกทั้งหมด N" ที่แถบ Export) ครึ่งเลือกแสดง
                      indeterminate เพราะ "บางแถว" ไม่ใช่ "ทุกแถว" และไม่ใช่ "ไม่มีแถว"
                    */}
                    <input
                      type="checkbox"
                      data-testid="so-select-page"
                      aria-label="เลือกใบสั่งขายทุกใบในหน้านี้"
                      checked={pageFullySelected}
                      ref={(node) => {
                        if (node !== null) {
                          node.indeterminate = pagePartlySelected;
                        }
                      }}
                      onChange={toggleWholePage}
                    />
                  </th>
                  <th scope="col">เลขที่ใบ</th>
                  <th scope="col">วันที่บันทึก</th>
                  <th scope="col">โรงงาน</th>
                  <th scope="col">ลูกค้า</th>
                  <th scope="col">เลข PO ของลูกค้า</th>
                  <th scope="col">
                    วันส่ง{' '}
                    <InfoHint
                      label="คอลัมน์วันส่งอ่านอย่างไร"
                      text="วันเดียวเมื่อทุกบรรทัดของใบต้องการของวันเดียวกัน และเป็นช่วง “วันเร็วสุด – วันช้าสุด” เมื่อต่างกัน — หัวใบสั่งขายไม่มีวันส่งของตัวเอง (D-118 ข้อ 3)"
                    />
                  </th>
                  <th scope="col">สถานะ</th>
                  <th scope="col">บรรทัด</th>
                  {anyRowHasActions ? <th scope="col">การดำเนินการ</th> : null}
                </tr>
              </thead>
              <tbody>
                {items.map((order) => {
                  const actions = offeredActions(order);
                  const outcome =
                    actionOutcome?.soId === order.so_id && actionOutcome.failure !== null
                      ? actionOutcome
                      : null;
                  const openedDetail =
                    detail !== null &&
                    (detail.status === 'ready'
                      ? detail.order.so_id === order.so_id
                      : detail.soId === order.so_id)
                      ? detail
                      : null;

                  return (
                    <tr
                      key={order.so_id}
                      data-testid={`so-row-${order.so_number}`}
                      data-status={order.status}
                    >
                      <td className="cap-table__check">
                        {/*
                          `aria-label` บอก **เลขที่ใบ** ไม่ใช่ "เลือกแถว" — ช่องที่
                          ประกาศว่า "เลือก" สิบช่องติดกันทำให้คนที่ฟังหน้าจอไม่รู้ว่า
                          กำลังจะ export ใบไหน (D-118 ข้อ 6)
                        */}
                        <input
                          type="checkbox"
                          data-testid={`so-select-${order.so_number}`}
                          aria-label={`เลือกใบสั่งขาย ${order.so_number}`}
                          checked={isRowSelected(order)}
                          onChange={() => {
                            toggleRow(order);
                          }}
                        />
                      </td>
                      <th scope="row" className="cap-table__row-head">
                        <code className="cap-table__code">{order.so_number}</code>
                      </th>
                      <td>
                        <code className="cap-table__code">{order.created_date}</code>
                      </td>
                      <td>
                        <code className="cap-table__code">{order.plant_code}</code>
                      </td>
                      <td>
                        <code className="cap-table__code">{order.customer_code}</code>
                      </td>
                      <td>
                        <code className="cap-table__code">
                          {order.customer_po_number}
                        </code>
                      </td>
                      <td>
                        <code
                          className="cap-table__code"
                          data-testid={`so-delivery-span-${order.so_number}`}
                        >
                          {salesOrderDeliverySpanLabel(
                            order.delivery_date_from,
                            order.delivery_date_to,
                          )}
                        </code>
                      </td>
                      <td>
                        <StatusBadge tone={salesOrderStatusTone(order.status)}>
                          {salesOrderStatusLabel(order.status)}
                        </StatusBadge>
                      </td>
                      <td>
                        {/**
                         * จำนวนบรรทัดมากับรายการ (D-118 ข้อ 4) — **ค่าเดียวกับคอลัมน์
                         * "จำนวนบรรทัด" ของไฟล์ Export** เพราะทั้งคู่อ่าน `line_count`
                         * ตัวเดียวกัน ไม่ใช่นับเอาเองสองที่
                         */}
                        <span data-testid={`so-line-count-${order.so_number}`}>
                          {order.line_count}
                        </span>{' '}
                        {/**
                         * **บรรทัดไม่ได้มากับรายการ** (contract ตัดออก) ปุ่มนี้จึงยิง
                         * `GET /{so_id}` ของ **ใบนี้ใบเดียว** ตอนที่มีคนอยากอ่านมันจริง
                         * ไม่ใช่ตอนโหลดตาราง — ตารางที่ดึงบรรทัดให้ครบทุกแถวล่วงหน้าคือ
                         * สิ่งเดียวกับที่ contract ตั้งใจเลี่ยงตอนตัดบรรทัดออก
                         */}
                        <button
                          type="button"
                          className="cap-button cap-button--ghost"
                          data-testid={`so-detail-open-${order.so_number}`}
                          disabled={openedDetail?.status === 'loading'}
                          onClick={() => {
                            void openDetail(order);
                          }}
                        >
                          {openedDetail?.status === 'loading'
                            ? 'กำลังโหลด…'
                            : 'ดูบรรทัด'}
                        </button>

                        {openedDetail?.status === 'ready' ? (
                          <ul data-testid={`so-detail-lines-${order.so_number}`}>
                            {openedDetail.order.lines.map((line) => (
                              <li key={line.customer_po_line_no}>
                                <code className="cap-table__code">
                                  {line.product_code}
                                </code>{' '}
                                {line.quantity} {line.uom_code} ต้องการวันที่{' '}
                                {requestedDeliveryDateLabel(line.requested_delivery_date)}{' '}
                                <span className="cap-table__muted">
                                  ({line.customer_po_line_no})
                                </span>
                                <SalesOrderLineRefs line={line} />
                              </li>
                            ))}
                          </ul>
                        ) : null}

                        {openedDetail?.status === 'failed' ? (
                          <SalesOrderFailureNotice
                            failure={openedDetail.failure}
                            context="detail"
                          />
                        ) : null}
                      </td>
                      {anyRowHasActions ? (
                        <td>
                          {actions.map((transition) => (
                            <button
                              key={transition}
                              type="button"
                              className="cap-button cap-button--ghost"
                              data-testid={`so-action-${transition}-${order.so_number}`}
                              disabled={busy}
                              onClick={() => {
                                void runTransition(order, transition);
                              }}
                            >
                              {pending?.kind === transition && pending.soId === order.so_id
                                ? 'กำลังส่ง…'
                                : salesOrderActionLabel(transition)}
                            </button>
                          ))}

                          {/**
                           * คำอธิบายอยู่ **ที่แถวที่ถูกปฏิเสธ** ไม่ใช่ลอยอยู่ท้ายหน้า —
                           * `CONFIRMER_MUST_DIFFER_FROM_CREATOR` คือกรณีที่ผู้ใช้ต้อง
                           * เห็นทันทีว่ามันเป็นเรื่องของ **ใบนี้** ไม่ใช่ของสิทธิ์เขา
                           */}
                          {outcome === null || outcome.failure === null ? null : (
                            <div data-testid="so-action-failure-slot">
                              <SalesOrderFailureNotice
                                failure={outcome.failure}
                                context={outcome.transition}
                              />
                              <p className="cap-notice__note">
                                ปุ่มที่กดคือ &quot;
                                {salesOrderActionLabel(outcome.transition)}&quot; ซึ่งพา
                                ใบไปที่{' '}
                                {salesOrderStatusLabel(
                                  salesOrderActionTargetStatus(outcome.transition),
                                )}
                              </p>
                            </div>
                          )}
                        </td>
                      ) : null}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/*
            D-118 ข้อ 1 — **ก่อนหน้า/ถัดไป ไม่ใช่เลขหน้า** "ก่อนหน้า" เดินย้อนกองของ
            cursor ที่เบราว์เซอร์เก็บไว้ ส่วน "ถัดไป" ปิดเมื่อเซิร์ฟเวอร์ไม่ส่ง
            `next_cursor` มา — ไม่ใช่เมื่อหน้าจอคำนวณเองว่าน่าจะหมดแล้ว (ซึ่งจะผิดทุก
            ครั้งที่หน้าสุดท้ายเต็มพอดี)
          */}
          <div className="cap-card__foot cap-pager" data-testid="so-pager">
            <span className="cap-pager__count">{rowRangeLabel}</span>
            <button
              type="button"
              className="cap-button cap-button--ghost"
              data-testid="so-page-prev"
              disabled={!hasPreviousPage}
              onClick={goToPreviousPage}
            >
              ก่อนหน้า
            </button>
            <button
              type="button"
              className="cap-button cap-button--ghost"
              data-testid="so-page-next"
              disabled={nextCursor === null}
              onClick={goToNextPage}
            >
              ถัดไป
            </button>
            <span className="cap-pager__count">
              สถานะที่ปุ่มอ้างถึง{' '}
              <InfoHint
                label="ความหมายของแต่ละสถานะ"
                text={SALES_ORDER_STATUS_DESCRIPTORS.map(
                  (descriptor) => `${descriptor.label} — ${descriptor.summary}`,
                ).join(' / ')}
              />
            </span>
          </div>
        </section>
      ) : null}
    </div>
  );
}
